// check max concurrent request per host name limit for browser (chrome default is 6)
// https://docs.pushtechnology.com/cloud/latest/manual/html/designguide/solution/support/connection_limitations.html
export const promisePool = (tasks, maxParallelRequest = 6) => {
  let numOfRequests = 0;
  let taskIndex = 0;
  let errorDetected = false; // Flag to stop tasks on error
  const resolved = new Array(tasks.length).fill(null);

  return new Promise(resolve => {
    const getNextTask = () => {
      if (errorDetected) {
        return; // Stop executing new tasks if an error is detected
      }
      if (numOfRequests < maxParallelRequest && taskIndex < tasks.length) {
        tasks[taskIndex]().then(handleResult(taskIndex)).catch(handleError(taskIndex));
        taskIndex++;
        numOfRequests++;
        getNextTask();
      } else if (numOfRequests === 0 && taskIndex === tasks.length) {
        resolve(resolved);
      }
    };
    const handleResult = index => result => {
      resolved[index] = result;
      numOfRequests--;
      getNextTask();
    };
    const handleError = index => error => {
      if (!errorDetected && `${error}`.includes('Network Error')) {
        errorDetected = true; // Set error flag to true to stop further tasks
      } else {
        handleResult(index);
      }
    };
    getNextTask();
  });
}